// toggle
document.addEventListener("DOMContentLoaded", function () {
  const toggles = document.querySelectorAll(".-js-toggle");

  toggles.forEach(toggle => {
    toggle.addEventListener("click", function () {
      const parentItem = this.closest(".item");
      const toggleList = parentItem.querySelector(".-js-toggle-list");

      // すべての -js-toggle-list を一旦閉じる
      document.querySelectorAll(".-js-toggle-list").forEach(list => {
        if (list !== toggleList) {
          list.style.display = "none";
        }
      });

      // 自分の -js-toggle-list をトグル
      if (toggleList.style.display === "block") {
        toggleList.style.display = "none";
      } else {
        toggleList.style.display = "block";
      }
    });
  });
});

// SP toggle
function isMobileView() {
  return window.innerWidth <= 980;
}

function closeAllSpToggleLists(exclude = null) {
  document.querySelectorAll(".-js-sp-toggle-list").forEach(list => {
    if (list !== exclude) {
      list.style.display = "none";
    }
  });
}

function updateSpToggleListsVisibility() {
  const displayValue = isMobileView() ? "none" : "block";
  document.querySelectorAll(".-js-sp-toggle-list").forEach(list => {
    list.style.display = displayValue;
  });
}

document.addEventListener("DOMContentLoaded", function () {
  updateSpToggleListsVisibility();

  document.querySelectorAll(".-js-sp-toggle").forEach(toggle => {
    toggle.addEventListener("click", function () {
      if (!isMobileView()) return;

      const parentItem = this.closest(".item");
      const spToggleList = parentItem.querySelector(".-js-sp-toggle-list");

      // 他のリストを閉じる
      closeAllSpToggleLists(spToggleList);

      // 自分のリストをトグル
      spToggleList.style.display = spToggleList.style.display === "block" ? "none" : "block";
    });
  });
});

window.addEventListener("resize", updateSpToggleListsVisibility);

